<script setup>
// Margens [topo, direita, base, esquerda] com cadeado (mesmo valor nos 4).
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  modelValue: { type: Array, default: () => [0, 0, 0, 0] },
  max: { type: Number, default: 120 },
  label: { type: String, default: '' },
});
const emit = defineEmits(['update:modelValue']);
const { t } = useI18n();
const locked = ref(false);
const SIDES = [
  'i-lucide-arrow-up',
  'i-lucide-arrow-right',
  'i-lucide-arrow-down',
  'i-lucide-arrow-left',
];

const setSide = (index, raw) => {
  const value = Math.min(props.max, Math.max(0, Math.round(Number(raw) || 0)));
  const next = locked.value
    ? [value, value, value, value]
    : props.modelValue.map((v, i) => (i === index ? value : v));
  emit('update:modelValue', next);
};
</script>

<template>
  <div class="flex flex-col gap-1.5">
    <div class="flex items-center justify-between">
      <span class="text-xs font-medium text-n-slate-11">{{ label }}</span>
      <button
        data-test="lock"
        type="button"
        class="text-xs"
        :class="locked ? 'text-n-brand' : 'text-n-slate-10'"
        :title="t('EMAIL_TEMPLATES.EDITOR.PROPS.PADDING_LOCK')"
        @click="locked = !locked"
      >
        <span :class="locked ? 'i-lucide-lock' : 'i-lucide-lock-open'" />
      </button>
    </div>
    <div class="grid grid-cols-4 gap-1">
      <label
        v-for="(icon, i) in SIDES"
        :key="icon"
        class="flex items-center gap-1 rounded-md border border-n-weak px-1.5 py-1"
      >
        <span :class="icon" class="size-3 shrink-0 text-n-slate-10" />
        <input
          type="number"
          min="0"
          :max="max"
          class="w-full bg-transparent text-xs text-n-slate-12 outline-none"
          :value="modelValue[i]"
          @input="setSide(i, $event.target.value)"
        />
      </label>
    </div>
  </div>
</template>
